import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import clsx from 'clsx';
import UniversesRoute from './routes/UniversesRoute';
import SlugsRoute from './routes/SlugsRoute';
import WorkspaceRoute from './routes/WorkspaceRoute';
import UniverseSettingsRoute from './routes/UniverseSettingsRoute';
import ChatRoute from './routes/ChatRoute';
import LibraryRoute from './routes/LibraryRoute';
import PlayerRoute from './routes/PlayerRoute';
import SettingsRoute from './routes/SettingsRoute';
import ArchiveRoute from './routes/ArchiveRoute';
import LogRoute from './routes/LogRoute';
import TabBar from './components/TabBar';
import TopBar from './components/TopBar';
import NowPlayingBarV2 from './components/NowPlayingBarV2';
import PlayerHostV2 from './components/PlayerHostV2';
import TokenPrompt from './components/TokenPrompt';
import OnboardingGuard from './components/OnboardingGuard';
import { usePlayerV2 } from './stores/usePlayerV2';
import './styles/app.css';

const IN_UNIVERSE_PATHS = ['/slugs', '/workspace', '/chat', '/universe-settings'];

export default function App() {
  const location = useLocation();
  const playerStatus = usePlayerV2((s) => s.status);
  const playerTitle = usePlayerV2((s) => s.title);

  const inUniverse = IN_UNIVERSE_PATHS.some(
    (p) => location.pathname === p || location.pathname.startsWith(p + '/')
  );
  const onPlayerRoute = location.pathname === '/player';
  const nowPlayingVisible =
    playerStatus !== 'idle' && !!playerTitle && !onPlayerRoute;

  return (
    <div className={clsx('app-shell', inUniverse && 'with-tabs')}>
      <PlayerHostV2 />
      <TopBar />
      <main
        className={clsx(
          'app-main',
          inUniverse && 'with-tabs',
          nowPlayingVisible && 'with-now-playing'
        )}
      >
        <Routes>
          <Route path="/" element={<UniversesRoute />} />
          <Route path="/slugs" element={<SlugsRoute />} />
          <Route path="/workspace" element={<WorkspaceRoute />} />
          <Route path="/universe-settings" element={<UniverseSettingsRoute />} />
          <Route path="/chat" element={<ChatRoute />} />
          <Route path="/chat/:chatId" element={<ChatRoute />} />
          <Route path="/library" element={<LibraryRoute />} />
          <Route path="/player" element={<PlayerRoute />} />
          <Route path="/settings" element={<SettingsRoute />} />
          <Route path="/archive" element={<ArchiveRoute />} />
          <Route path="/log" element={<LogRoute />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      {nowPlayingVisible && <NowPlayingBarV2 />}
      <TabBar />
      <TokenPrompt />
      <OnboardingGuard />
    </div>
  );
}
